"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _PropTypesRegistry = _interopRequireDefault(require("./PropTypesRegistry"));

var customTypes = _interopRequireWildcard(require("./propTypes/index"));

var _default = new _PropTypesRegistry.default(_react.default.PropTypes).registerAll(customTypes);

exports.default = _default;
module.exports = exports.default;